import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import MainComponent from "../../../../components/ui_comps/MainComponent";
import {
  ADMIN_USER,
  CUSTOMER_EDIT,
  RNC,
  STATUS_CODE_200,
} from "../../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { BiEditAlt } from "react-icons/bi";
import CustomTabs from "../../../../components/main_comps/custom_tabs";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import BasicDetails from "./BasicDetails";
import { SS_ROLE } from "../../../../../utility/constants/secureStorageManager";
import secureStorage from "../../../../../services/secureStorage";
import {
  validateEmail,
  validateUpi,
} from "../../../../../utility/emailValidator";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
const tabs = [{ name: "Basic Details", key: 0 }];

const ActionComponent = ({
  step,
  onClickEdit,
  isEditClicked,
  onClickSave,
  aclData,
  data,
}) => {
  const navigate = useNavigate();
  return (
    <div style={{ display: "flex" }}>
      {(step === 0 || step === 1 || step === 3) && (
        <>
          {aclData?.includes(CUSTOMER_EDIT) && (
            <CustomButton
              ionDirection="left"
              icon={
                isEditClicked ? null : <BiEditAlt size={16} color="white" />
              }
              styles={{
                backgroundColor: isEditClicked ? "transparent" : "#38369C",
                border: isEditClicked
                  ? "1px solid #1E2234"
                  : "1px solid #38369C",
                marginLeft: "10px",
              }}
              title={isEditClicked ? "Cancel" : "Edit"}
              textStyles={{ color: isEditClicked ? "#1E2234" : "white" }}
              onClick={onClickEdit}
            />
          )}
          {isEditClicked && (
            <CustomButton
              ionDirection="left"
              icon={<BiEditAlt size={16} color="white" />}
              styles={{
                backgroundColor: "#38369C",
                border: "1px solid #38369C",
                marginLeft: "10px",
              }}
              title={"Save"}
              textStyles={{ color: "white" }}
              onClick={onClickSave}
            />
          )}
        </>
      )}
    </div>
  );
};
const CustomerDetailsIndex = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [customerDetails, setCustomerDetails] = useState({});
  const [currentTab, setCurrentTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isEditClicked, setIsEditClicked] = useState(false);
  const role = secureStorage.getItem(SS_ROLE);
  const aclData = useSelector((state) => state.aclSlice.aclList);
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    if (state?.data) {
      setCustomerDetails(state.data);
    }
  }, [state?.data]);
  const onClickEditCustomer = () => {
    if (customerDetails?.email && !validateEmail(customerDetails?.email)) {
      enqueueSnackbar("Invalid email id", {
        variant: "error",
      });
      return;
    }
    if (customerDetails?.upi && !validateUpi(customerDetails?.upi)) {
      enqueueSnackbar("Invalid UPI", {
        variant: "error",
      });
      return;
    }
    if (
      customerDetails?.mobileNumber &&
      customerDetails?.mobileNumber.length != 10
    ) {
      enqueueSnackbar("Invalid Mobile Number", {
        variant: "error",
      });
      return;
    }

    ApiRequestPost.updateCustomer({
      customerName: customerDetails?.customerName,
      email: customerDetails?.email,
      mobileNumber: customerDetails?.mobileNumber,
      upi: customerDetails?.upi,
      type: customerDetails?.type,
      customerId: state?.data?.customerId,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          navigate("/risk-management");
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      });
  };
  const handleTabChange = useCallback((tab) => {
    setCurrentTab(tab);
  }, []);

  return (
    <div
      style={{
        width: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        backgroundColor: "white",
      }}
    >
      <MainComponent
        notificationRequired={false}
        filterRequired={false}
        backActionRequired={true}
        headerTitle={state?.data?.customerName}
      />
      <CustomTabs
        tabs={tabs}
        backgroundrequired={false}
        activeIndex={currentTab}
        passCurrentTab={(data) => handleTabChange(data)}
        actionComponent={
          <ActionComponent
            loading={loading}
            step={currentTab}
            data={state?.data}
            onClickEdit={() => {
              setIsEditClicked(!isEditClicked);
            }}
            isEditClicked={isEditClicked}
            onClickSave={() => {
              onClickEditCustomer();
            }}
            aclData={aclData}
          />
        }
      />

      <BasicDetails
        data={state?.data}
        isEditClicked={isEditClicked}
        onChange={(val) => {
          setCustomerDetails({ ...val });
        }}
      />
    </div>
  );
};

export default CustomerDetailsIndex;
